import React, { Component } from 'react';
import {
  MenuModal,
  MenuModalItem,
  MenuModalItemImage,
  MenuModalItemText,
} from 'components/styles/Common.styled';
import ReactDOM from 'react-dom';
import { deepClone } from 'utils/common/deepClone';
import { trackPageItem } from 'components/main/common/utils';
import MenuId from 'enum/menu-id.enum';
import { measureComponent } from 'utils/common/measureComponent';

class MenuModalWithActiveItem extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.activeRef = null;
    this.state = {
      allowedItems: 5, // Default value until measurement
    };
  }

  componentDidMount() {
    this.calculateAllowedItems();
    this.trackNewsItem();
  }

  renderMenuItem(item) {
    const { template, showImages } = this.props;
    return (
      <MenuModalItem template={template}>
        {showImages && item.image && (
          <MenuModalItemImage template={template}>
            <img src={item.image} alt='' width='80px' height='80px' loading='lazy' />
          </MenuModalItemImage>
        )}
        <MenuModalItemText template={template}>{item.text}</MenuModalItemText>
      </MenuModalItem>
    );
  }

  getMeasurements() {
    const sampleItem = {
      active: false,
      text: 'Sample Item',
      image: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    };

    return measureComponent(() => this.renderMenuItem(sampleItem));
  }

  async calculateAllowedItems() {
    const totalItems = await this.getMeasurements();
    this.setState({ allowedItems: totalItems });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeIndex !== this.props.activeIndex) {
      this.trackNewsItem();
      this.centerActiveItem();
    }
  }

  trackNewsItem() {
    const { items, activeIndex } = this.props;
    if (items && items[activeIndex]) {
      trackPageItem(MenuId.NEWS, items[activeIndex].text);
    }
  }

  centerActiveItem() {
    const scrollContainer = ReactDOM.findDOMNode(this.scrollRef.current);
    const activeItem = ReactDOM.findDOMNode(this.activeRef);

    if (!activeItem || !scrollContainer) {
      return;
    }

    const scrollRect = scrollContainer.getBoundingClientRect();
    const activeRect = activeItem.getBoundingClientRect();

    scrollContainer.scrollLeft +=
      activeRect.left - scrollRect.left - (scrollRect.width / 2 - activeRect.width / 2);
  }

  generateDisplayedItems() {
    const { items, activeIndex } = this.props;
    const { allowedItems } = this.state;
    const totalItems = items.length;
    const displayedItems = [];

    // Ensure we always display an odd number of items for center alignment
    const maxIterations = Math.min(
      allowedItems,
      totalItems % 2 !== 0 ? totalItems : totalItems - 1
    );
    for (let i = 0; i < maxIterations; i++) {
      const index = (activeIndex - Math.floor(maxIterations / 2) + i + totalItems) % totalItems;
      const item = deepClone(items[index]);
      item.active = index === activeIndex;
      displayedItems.push(item);
    }

    return displayedItems;
  }

  render() {
    const { onItemClick } = this.props;
    const displayedItems = this.generateDisplayedItems();

    return (
      <MenuModal ref={this.scrollRef}>
        {displayedItems.map((item, index) => (
          <div
            key={index}
            ref={(ref) => {
              if (item.active) {
                this.activeRef = ref;
              }
            }}
            onClick={() => onItemClick(item)}
          >
            {React.cloneElement(this.renderMenuItem(item), { active: item.active })}
          </div>
        ))}
      </MenuModal>
    );
  }
}

export default MenuModalWithActiveItem;
